<script lnag="ts">
	import { XIcon } from "@hitit/new_ui/src";
	import { Popper, Selectabled } from "@hitit/new_ui/src";
	import { t, notifications } from "../../../stores";

</script>

<div class="notification-container">
	<div class="notifications">
		{#each $notifications as notification, idx}
			<div class="notification">
				<div class="notification-logo">
					{#if notification.type === 'ERROR'}
						<Popper fill="#f66d6c" />
					{:else if notification.type === 'INFO'}
						<Popper fill="#bcbfc3" />
					{:else if notification.type === 'SUCCESS'}
						<Selectabled fill="#4AE2B0" />
					{:else if notification.type === 'CONFIRM'}
						<Popper fill="#229a6c" />
					{/if}
				</div>
				<div class="notification-content">
					<div class="notification-top">
						<div
							class="notification-title"
							class:is-error={notification.type === 'ERROR'}
							class:is-info={notification.type === 'INFO'}
							class:is-success={notification.type === 'SUCCESS'}
							class:is-confirm={notification.type === 'CONFIRM'}>
							{notification.title || $t('hub.app.notification.' + notification.type.toLowerCase())}
						</div>
					</div>
					<div class="notification-message">
						{@html notification.message}
					</div>
					{#if notification.type === 'CONFIRM'}
						<div class="notification-confirm">
							<button
								type="button"
								class="notification-button"
								on:click={() => notifications.confirm(idx, notification.callback)}>
								OK
							</button>
							<button
								type="button"
								class="notification-button"
								on:click={() => notifications.remove(idx)}>
								CANCEL
							</button>
						</div>
					{/if}
				</div>
				{#if notification.type !== 'CONFIRM'}
					<div
						class="notification-delete"
						on:click={() => notifications.remove(idx)}>
						<XIcon fill={'#bcbfc3'} />
					</div>
				{/if}
			</div>
		{/each}
	</div>
</div>

<style lang="scss">
	@import "../../../variables.scss";

	.notification-container {
		position: fixed;
		left: 50%;
		bottom: 0;
		z-index: 99999;
		transform: translateX(-50%);
		animation: yAxisMove 1.5s;
		animation-delay: 1s;
		animation-fill-mode: backwards;
	}

	@keyframes yAxisMove {
		0% {
			transform: translate(-50%, 100%);
		}
		100% {
			transform: translate(-50%, 0%);
		}
	}

	.notification {
		display: flex;
		position: relative;
		width: 320px;
		padding: 20px 16px;
		background-color: #46474b;
		border-top-left-radius: 30px;
		border-top-right-radius: 30px;
		box-shadow: var(--shadow-large);
	}

	.notification-content {
		display: flex;
		flex-direction: column;
		gap: 8px;
		flex: 1;
	}
	.notification-top {
		display: flex;
		align-items: center;
	}

	.notification-logo {
		width: 20px;
		height: 20px;
		margin-right: 10px;

		.is-error & {
			color: var(--red);
		}
		.is-info & {
			color: var(--lightGrey);
		}
		.is-success & {
			color: var(--green);
		}
	}

	.notification-message {
		flex: 1;
		color: white;
		width: auto;
		font-size: 1rem;
		line-height: 25px;
		letter-spacing: -0.8px;
	}

	.notification-title {
		font-size: 1rem;
		font-weight: bold;

		&.is-error {
			color: var(--red);
		}
		&.is-info {
			color: var(--lightGrey);
		}
		&.is-success {
			color: var(--green);
		}
		&.is-confirm {
			color: var(--green);
		}
	}

	.notification-delete {
		position: absolute;
		right: calc(0% + 20px);
		top: calc(0% + 20px);
		width: 20px;
		height: 20px;
		margin-left: auto;
		cursor: pointer;
	}

	@include DesktopSize {
		.notification-container {
			left: unset;
			right: 0;
			bottom: unset;
			padding-top: 16px;
			transform: none;
			animation: xAxisMove 1.5s;
			animation-delay: 1s;
			animation-fill-mode: backwards;
		}

		@keyframes xAxisMove {
			0% {
				transform: translateX(100%);
			}
			100% {
				transform: translateX(0%);
			}
		}

		.notification {
			width: auto;
			padding: 16px 12px;
			margin-bottom: 8px;
			border-top-right-radius: 0px;
			border-top-left-radius: 5px;
			border-bottom-left-radius: 5px;
		}

		.notification-message {
			width: max-content;
			min-width: 200px;
			margin-right: 25px;
			font-size: 1.25rem;
		}

		.notification-title {
			font-size: 1.25rem;
		}

		.notification-delete {
			right: calc(0% + 10px);
			top: calc(0% + 10px);
		}
	}

</style>
